/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import { createApp } from 'vue'
import Axios from "axios";
import store from "../store";
import { router } from "./vue-router";

Axios.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response.status == 401) {

            store.dispatch("auth/logout");

        }

        if (error.response.status == 403) {
            router.push({
                name : "unauthorized"
            });
        }

        if (error.response.status == 405) {
            router.push({
                name : "404"
            });
        }

        if (error.response.status >= 500) {
            window.toastr.error('Something Went Wrong!');
        }

        return Promise.reject(error);
    }
);

Axios.interceptors.request.use(
    (config) => {
         // login token key lifetime refresher
        store.dispatch('auth/refresh_token_lifetime');
        
        return config;
    }
);

